// extracted by mini-css-extract-plugin
export default {"filesList":"UploadFilesModalList_filesList__vEOyL"};